import { useEffect } from 'react';
import { useFormState } from 'shared';

export function useReaderForm(reader, onChangeInput) {
  const [readerInputs, setReaderInputs] = useFormState(reader, onChangeInput);

  useEffect(() => {
    setReaderInputs({ ...reader }, false);
  }, [reader]);

  const handleChange =
    fieldName =>
    ({ target }) => {
      setReaderInputs(inputs => ({ ...inputs, [fieldName]: target.value }));
    };

  return {
    readerInputs,
    handleChange
  };
}
